import { Fragment, useRef, useState,useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import axios from '../../axios'
import Centre from '../Dropdowns/Centre'
import AuthContext from "../../AuthContext";
import {toast} from 'react-toastify'
export default function UpdateProduct({
  updateProductData,
  updateModalSetting,
  handlePageUpdate
}) 
{
    const {full_name,centre_id,balance_leaves} = updateProductData;
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const authContext = useContext(AuthContext);

const dont=true
  const formatDateToInput = (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const[centre,setCentre]=useState('')
  const [employee, setEmployee] = useState({
    full_name:full_name,
    date:'',
    added_leaves:balance_leaves,
    taken_leaves:0,
    remark:"",
   });
   const Tbalance_leaves=employee.added_leaves-employee.taken_leaves
   const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmployee(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const updateProduct = () => {
    const requiredFields=[
      employee.date,
    ]
    const isValid = requiredFields.every(field => field && (Array.isArray(field) ? field.length > 0 : true));
    
    if (!isValid) {
        toast.error('Please fill in all required fields');
        return;
    }
    axios.post('/employee/insert',{
      full_name:employee.full_name,
      date:employee.date,
      added_leaves:employee.added_leaves,
      taken_leaves:employee.taken_leaves,
      balance_leaves:Tbalance_leaves,
      remark:employee.remark,
    })
        .then((result) => {          
          handlePageUpdate();
         updateModalSetting()
        })
        .catch((err) =>{ 
          toast.error('Something went wrong') 
          console.log(err)});
        setOpen(false);
    };
    
  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg
               bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Update Leaves
                      </Dialog.Title>
                      <form action="#">
                       
                        <div className="grid gap-4 mb-4 sm:grid-cols-3">
                      
                          <div>
                            <label
                                htmlFor="date"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >
                                Date<span className='text-red-700 '>*</span>
                              </label>
                              <input
                               type="date"
                               id="date"
                               name="date"
                               value={employee.date}
                               onChange={handleInputChange}
                               className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark
                               :focus:border-blue-500"
                               
                               />
                            </div>
                           
                            <div>
                            <label htmlFor="full_name"  
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                              Full Name <span className='text-red-600'>*</span>

                            </label>
                            <input type='text' 
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="full_name"
                            name="full_name"
                            value={employee.full_name}
                            onChange={handleInputChange}
                            />
                           
                           </div>

                           <div>
                            <label htmlFor="added_leaves"  
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                              Total Leaves <span className='text-red-600'>*</span></label>
                            <input type='number'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="added_leaves"
                            name="added_leaves"
                            value={employee.added_leaves}
                            onChange={handleInputChange}
                            />
                           
                           </div>
                          
                          
                           <div>
                            <label htmlFor="taken_leaves"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Leaves Taken <span className='text-red-600'>*</span></label>
                            <input type='number'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="taken_leaves"
                            name="taken_leaves"
                            value={employee.taken_leaves}
                            onChange={handleInputChange}
                            />
                           
                           </div>
                           <div>
                            <label htmlFor="balance_leaves"  
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                              Balance Leaves <span className='text-red-600'>*</span></label>
                            <input type='text'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="balance_leaves"
                            name="balance_leaves"
                            value={Tbalance_leaves}
                            onChange={handleInputChange}
                            />
                           
                           </div>
                           <div>
                            <label htmlFor="remark"  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Remark</label>
                            <input type='text'
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            id="remark"
                            name="remark"
                            value={employee.remark}
                            onChange={handleInputChange}
                            />
                           
                           </div>
                           
                        </div>
                        <div className="flex items-center space-x-4">
                          {/* <button
                            type="submit"
                            className="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
                          >
                            Update product
                          </button> */}
                          {/* <button
                            type="button"
                            className="text-red-600 inline-flex items-center hover:text-white border border-red-600 hover:bg-red-600 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:border-red-500 dark:text-red-500 dark:hover:text-white dark:hover:bg-red-600 dark:focus:ring-red-900"
                          >
                            <svg
                              className="mr-1 -ml-1 w-5 h-5"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                            Delete
                          </button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                    onClick={updateProduct}
                  >
                  Save
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => updateModalSetting()}
                    ref={cancelButtonRef}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
